import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';

const items = [
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
      </svg>
    ),
    title: 'Notas de prensa',
    description:
      'Comunicados oficiales con el sello TNO Network: distribución a medios y redes. Tu marca dentro del relato institucional de Expo Mascotas Caracas.',
    price: 50,
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
    ),
    title: 'Contenido escrito en TNO Digest',
    description:
      'Artículos y crónicas sobre el evento, sus marcas aliadas y las historias que hacen más feliz la vida de nuestros peludos.',
    price: 80,
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Reseñas y valoración',
    description:
      'Reseñas del evento y mención destacada de las marcas en el balance posterior, con enfoque emocional y profesional.',
    price: 40,
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    title: 'Dossier de prensa',
    description:
      'Kit de prensa con fotos, datos del evento y menciones de patrocinadores, listo para periodistas y aliados estratégicos.',
    price: 50,
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    title: 'Reportaje post-evento',
    description:
      'Resumen ejecutivo con cifras, testimonios y presencia de marca. Ideal para redes, memorias y comunicaciones internas.',
    price: 40,
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
      </svg>
    ),
    title: 'Menciones en señal y redes',
    description:
      'Cuñas, menciones y clips durante la cobertura y publicaciones asociadas. Tu marca en el relato vivo de la Expo.',
    price: 40,
  },
];

const ContenidoParaMarcas = () => {
  const theme = useTheme();
  const totalPrecio = items.reduce((sum, item) => sum + item.price, 0);

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          gutterBottom
          color="primary"
          align="center"
        >
          Para las marcas que patrocinan
        </Typography>
        <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
          Contenido escrito, prensa y reseñas
        </Typography>
        <Typography variant="h6" component="p" color="textSecondary" align="center" sx={{ maxWidth: 760, mx: 'auto' }}>
          Para el evento y para las marcas participantes. Además de la cobertura
          en vivo, cada patrocinador recibe material editorial y de prensa con la
          autoridad de TNO Network: contenido sobre Expo Mascotas Caracas y sobre
          su marca distribuido en el ecosistema.
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={i} data-aos="fade-up">
            <Box
              component={Card}
              height="100%"
              variant="outlined"
              sx={{
                transition: 'all .2s ease-in-out',
                '&:hover': {
                  boxShadow: 4,
                  borderColor: theme.palette.primary.main,
                },
              }}
            >
              <CardContent>
                <Box
                  component={Avatar}
                  variant="rounded"
                  sx={{
                    width: 56,
                    height: 56,
                    mb: 2,
                    bgcolor: `${theme.palette.primary.light}33`,
                    color: theme.palette.primary.dark,
                  }}
                >
                  {item.icon}
                </Box>
                <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                  {item.description}
                </Typography>
                <Typography variant="h6" fontWeight={700} color="primary">
                  ${item.price}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box
        component={Card}
        sx={{
          mt: 4,
          borderLeft: 4,
          borderColor: theme.palette.primary.main,
          bgcolor: theme.palette.primary.main,
          color: theme.palette.common.white,
        }}
      >
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
            <Typography variant="h6" fontWeight={700} sx={{ color: theme.palette.common.white }}>
              Total paquete contenido escrito y prensa
            </Typography>
            <Typography variant="h5" fontWeight={900} sx={{ color: theme.palette.common.white }}>
              ${totalPrecio}
            </Typography>
          </Box>
        </CardContent>
      </Box>
    </Box>
  );
};

export default ContenidoParaMarcas;
